import { JobCategory, TrainingTrack } from '../../Bridges/ManagerValidation/_constants';

export class JobCategoryDTO {
	constructor(objJobCategory) {
		/**
		 * @type {number}
		 */
		this.jobCategoryID = objJobCategory?.jobCategoryID ?? '';
		/**
		 * @type {string}
		 */
		this.name = objJobCategory?.name ?? '';
		/**
		 * @type {string}
		 */
		this.description = objJobCategory?.description ?? '';
		/**
		 * @type {string}
		 */
		this.type = objJobCategory?.type ?? '';
		/**
		 * @type {number}
		 */
		this.appID = objJobCategory?.appID ?? 1616;
		/**
		 * @type {string}
		 */
		this.owningApplication = objJobCategory?.owningApplication ?? '';
		/**
		 * @type {string}
		 */
		this.templateID = objJobCategory?.templateID ?? '';
		/**
		 * @type {string}
		 */
		this.templateName = objJobCategory?.templateName ?? '';
		/**
		 * @type {string}
		 */
		this.subtemplateIDs = objJobCategory?.subtemplateIDs ?? '';
		/**
		 * @type {string}
		 */
		this.subtemplateNames = objJobCategory?.subtemplateNames ?? '';
		/**
		 * @type {boolean}
		 */
		this.isProvider = objJobCategory?.isProvider ?? '';
		/**
		 * @type {boolean}
		 */
		this.SER = objJobCategory?.SER ?? '';
		/**
		 * @type {string}
		 */
		this.SERBlueprintID = objJobCategory?.SERBlueprintID ?? '';
		/**
		 * @type {TrainingTrackDTO}
		 */
		this.trainingTrack1 = objJobCategory?.trainingTrack1 ?? '';
		/**
		 * @type {TrainingTrackDTO}
		 */
		this.trainingTrack2 = objJobCategory?.trainingTrack2 ?? '';
		/**
		 * @type {TrainingTrackDTO}
		 */
		this.trainingTrack3 = objJobCategory?.trainingTrack3 ?? '';
		/**
		 * @type {TrainingTrackDTO}
		 */
		this.trainingTrack4 = objJobCategory?.trainingTrack4 ?? '';
		/**
		 * @type {TrainingTrackDTO}
		 */
		this.trainingTrack5 = objJobCategory?.trainingTrack5 ?? '';
		/**
		 * @type {TrainingTrackDTO}
		 */
		this.trainingTrack6 = objJobCategory?.trainingTrack6 ?? '';
		/**
		 * @type {TrainingTrackDTO}
		 */
		this.trainingTrack7 = objJobCategory?.trainingTrack7 ?? '';
		/**
		 * @type {TrainingTrackDTO}
		 */
		this.trainingTrack8 = objJobCategory?.trainingTrack8 ?? '';
		/**
		 * @type {string}
		 */
		this.dayInTheLifeActivityPreLive =
			objJobCategory?.dayInTheLifeActivityPreLive ?? '';
		/**
		 * @type {string}
		 */
		this.dayInTheLifeActivityPostLive =
			objJobCategory?.dayInTheLifeActivityPostLive ?? '';
		/**
		 * @type {string}
		 */
		this.note = objJobCategory?.note ?? '';
		/**
		 * @type {boolean}
		 */
		this.active = objJobCategory?.active ?? true;
		/**
		 * @type {string}
		 */
		this.createUser = objJobCategory?.createUser ?? '';
		/**
		 * @type {string}
		 */
		this.maintenanceUser = objJobCategory?.maintenanceUser ?? '';
	}
	extractValues() {
		return {
			jobCategoryID: this.jobCategoryID ?? -1,
			name: this.name,
			description: this.description,
			type: this.type,
			appID: this.appID,
			owningApplication: this.owningApplication,
			templateID: this.templateID,
			templateName: this.templateName,
			subtemplateIDs: this.subtemplateIDs,
			subtemplateNames: this.subtemplateNames,
			isProvider: this.isProvider,
			SER: this.SER,
			SERBlueprintID: this.SERBlueprintID,
			trainingTrack1: this.trainingTrack1,
			trainingTrack2: this.trainingTrack2,
			trainingTrack3: this.trainingTrack3,
			trainingTrack4: this.trainingTrack4,
			trainingTrack5: this.trainingTrack5,
			trainingTrack6: this.trainingTrack6,
			trainingTrack7: this.trainingTrack7,
			trainingTrack8: this.trainingTrack8,
			dayInTheLifeActivityPreLive: this.dayInTheLifeActivityPreLive,
			dayInTheLifeActivityPostLive: this.dayInTheLifeActivityPostLive,
			note: this.note,
			active: this.active,
			createUser: this.createUser,
			maintenanceUser: this.maintenanceUser,
		};
	}

	prepare(loggedInUser, isNew = false) {
		return {
			jobCategoryID: this.jobCategoryID,
			name: this.name,
			description: this.description,
			type: this.type,
			appID: this.appID,
			owningApplication: this.owningApplication,
			templateID: this.templateID,
			templateName: this.templateName,
			subtemplateIDs: this.subtemplateIDs,
			subtemplateNames: this.subtemplateNames,
			isProvider: this.isProvider,
			SER: this.SER,
			SERBlueprintID: this.SERBlueprintID,
			trainingTrack1: this.trainingTrack1?.id,
			trainingTrack2: this.trainingTrack2?.id,
			trainingTrack3: this.trainingTrack3?.id,
			trainingTrack4: this.trainingTrack4?.id,
			trainingTrack5: this.trainingTrack5?.id,
			trainingTrack6: this.trainingTrack6?.id,
			trainingTrack7: this.trainingTrack7?.id,
			trainingTrack8: this.trainingTrack8?.id,
			dayInTheLifeActivityPreLive: this.dayInTheLifeActivityPreLive,
			dayInTheLifeActivityPostLive: this.dayInTheLifeActivityPostLive,
			note: this.note,
			active: isNew ? true : this.active,
			createUser: isNew ? loggedInUser?.NetworkID : this.createUser,
			maintenanceUser: loggedInUser?.NetworkID ?? this.maintenanceUser,
		};
	}

	setTrainingTrack(index, value) {
		switch (index) {
			case 1:
				this.trainingTrack1 = value;
				break;
			case 2:
				this.trainingTrack2 = value;
				break;
			case 3:
				this.trainingTrack3 = value;
				break;
			case 4:
				this.trainingTrack4 = value;
				break;
			case 5:
				this.trainingTrack5 = value;
				break;
			case 6:
				this.trainingTrack6 = value;
				break;
			case 7:
				this.trainingTrack7 = value;
				break;
			case 8:
				this.trainingTrack8 = value;
				break;
			default:
				break;
		}
		this.department = value;
	}
}

export class TrainingTrackDTO {
	constructor(objTrainingTrack) {
		/**
		 * @type {number}
		 */
		this.trainingTrackID = objTrainingTrack?.trainingTrackID ?? '';
		/**
		 * @type {string}
		 */
		this.name = objTrainingTrack?.name ?? '';
		/**
		 * @type {boolean}
		 */
		this.active = objTrainingTrack?.active ?? true;
		/**
		 * @type {string}
		 */
		this.createUser = objTrainingTrack?.createUser ?? '';
		/**
		 * @type {string}
		 */
		this.maintenanceUser = objTrainingTrack?.maintenanceUser ?? '';
	}

	extractValues() {
		return {
			trainingTrackID: this.trainingTrackID,
			name: this.name,
			active: this.active,
			createUser: this.createUser,
			maintenanceUser: this.maintenanceUser,
		};
	}

	prepare(loggedInUser, isNew = false) {
		return {
			trainingTrackID: this.trainingTrackID,
			name: this.name,
			active: isNew ? true : this.active,
			createUser: isNew ? loggedInUser?.NetworkID : this.createUser,
			maintenanceUser: loggedInUser?.NetworkID ?? this.maintenanceUser,
		};
	}
}

export class JobCategoryMappingDTO {
	constructor(objJobCategoryMapping) {
		/**
		 * @type {number}
		 */
		this.id = objJobCategoryMapping?.id ?? '';
		/**
		 * @type {string}
		 */
		this.department = objJobCategoryMapping?.department ?? '';
		/**
		 * @type {string}
		 */
		this.jobTitle = objJobCategoryMapping?.jobTitle ?? '';
		/**
		 * @type {JobCategoryDTO}
		 */
		this.jobCategoryID = objJobCategoryMapping?.jobCategoryID ?? '';
		/**
		 * @type {boolean}
		 */
		this.active = objJobCategoryMapping?.active ?? true;
		/**
		 * @type {string}
		 */
		this.createUser = objJobCategoryMapping?.createUser ?? '';
		/**
		 * @type {string}
		 */
		this.maintenanceUser = objJobCategoryMapping?.maintenanceUser ?? '';
	}
	extractValues() {
		return {
			id: this.id,
			department: this.department,
			jobTitle: this.jobTitle,
			jobCategoryID: this.jobCategoryID,
			active: this.active,
			createUser: this.createUser,
			maintenanceUser: this.maintenanceUser,
		};
	}

	prepare(loggedInUser, isNew = false) {
		return {
			id: this.id,
			department: this.department?.label,
			jobTitle: this.jobTitle?.label,
			jobCategoryID: this.jobCategoryID?.id,
			active: isNew ? true : this.active,
			createUser: isNew ? loggedInUser?.NetworkID : this.createUser,
			maintenanceUser: loggedInUser?.NetworkID ?? this.maintenanceUser,
		};
	}

	setDepartment(value) {
		this.department = value;
	}

	setJobCategory(value) {
		this.jobCategoryID = value;
	}

	setJobTitle(value) {
		this.jobTitle = value;
	}
}

export class JobCategoryMappingNewDTO {
	constructor(objJobCategoryMapping) {
		/**
		 * @type {number}
		 */
		this.id = objJobCategoryMapping?.id ?? '';
		/**
		 * @type {string}
		 */
		this.department = objJobCategoryMapping?.department ?? null;
		/**
		 * @type {string}
		 */
		this.jobTitle = objJobCategoryMapping?.jobTitle ?? null;
		/**
		 * @type {JobCategoryDTO[]}
		 */
		this.jobCategoryIDs = objJobCategoryMapping?.jobCategoryIDs ?? [];
		/**
		 * @type {boolean}
		 */
		this.active = objJobCategoryMapping?.active ?? true;
		/**
		 * @type {string}
		 */
		this.createUser = objJobCategoryMapping?.createUser ?? '';
		/**
		 * @type {string}
		 */
		this.maintenanceUser = objJobCategoryMapping?.maintenanceUser ?? '';
	}
	extractValues() {
		return {
			id: this.id,
			department: this.department,
			jobTitle: this.jobTitle,
			jobCategoryIDs: this.jobCategoryIDs,
			active: this.active,
			createUser: this.createUser,
			maintenanceUser: this.maintenanceUser,
		};
	}

	prepare(loggedInUser, isNew = false) {
		return {
			id: this.id,
			department: this.department?.label,
			jobTitle: this.jobTitle?.label,
			jobCategoryIDs: this.jobCategoryIDs?.map(jc => jc.id),
			active: isNew ? true : this.active,
			createUser: isNew ? loggedInUser?.NetworkID : this.createUser,
			maintenanceUser: loggedInUser?.NetworkID ?? this.maintenanceUser,
		};
	}

	setDepartment(value) {
		this.department = value;
	}

	addJobCategory(value) {
		this.jobCategoryIDs.push(value);
	}

	setJobTitle(value) {
		this.jobTitle = value;
	}
}

export class SearchResult {
	constructor(objSearchResult) {
		/**
		 * @type {number}
		 */
		this.id = objSearchResult.Key;
		/**
		 * @type {string}
		 */
		this.label = objSearchResult.Value;
	}
}

export class UserSearchResult {
	constructor(objUserSearchResult) {
		/**
		 * User unique identifier;
		 * @type {number}
		 */
		this.id = objUserSearchResult?.ID;
		/**
		 * User first name.
		 * @type {string}
		 */
		this.firstName = objUserSearchResult?.FirstName;
		/**
		 * User last name.
		 * @type {string}
		 */
		this.lastName = objUserSearchResult?.LastName;
		/**
		 * User middle initial.
		 * @type {string}
		 */
		this.middleInitial = objUserSearchResult?.MiddleInitial;
		/**
		 * User department.
		 * @type {string}
		 */
		this.department = objUserSearchResult?.Department;
		/**
		 * User job title.
		 * @type {string}
		 */
		this.jobTitle = objUserSearchResult?.JobTitle;
		/**
		 * Email address of user's supervisor.
		 * @type {string}
		 */
		this.emailManager = objUserSearchResult?.ManagerEmail;
		/**
		 * User User Principal Name.
		 * @type {string}
		 */
		this.upn = objUserSearchResult?.UPN;
		/**
		 * Collection of user's job category assignments.
		 * @type {AssignmentDetails[]}
		 */
		this.assignments = objUserSearchResult?.Assignments;
		/**
		 * Verbal representation of user's IMS Epic (Bridges) application access.
		 * @type {'Yes'|'No'|string}
		 */
		this.appAccess = objUserSearchResult?.AppAccess;
		/**
		 * Indicates whether or not user has an EMP.
		 * @type {boolean}
		 */
		this.empExists = objUserSearchResult?.IsExists ?? false;
		/**
		 * EMP active status.
		 * @type {boolean}
		 */
		this.empActive = objUserSearchResult?.IsActive ?? false;
		/**
		 * Human-readable EMP login block status.
		 * @type {string|null}
		 */
		this.empBlock = objUserSearchResult?.BlockStatus
			? objUserSearchResult.BlockStatus.IsBlocked
				? `Yes (${objUserSearchResult.BlockStatus.Reason})`
				: 'No'
			: null;
	}
}

export class AssignmentDetails {
	constructor(objAssignment){
		/**
		 * Job category assignment unique identifier.
		 * @type {number}
		 */
		this.id = objAssignment.id;
		/**
		 * Job category of assignment.
		 * @type {JobCategory}
		 */
		this.jobCategory = objAssignment.jobCategory;
		/**
		 * Validation state of assignment.
		 * @type {boolean}
		 */
		this.validated = objAssignment.validated;
		/**
		 * Experienced state of assignment.
		 * @type {boolean}
		 */
		this.experienced = objAssignment.experienced;
		/**
		 * Wave of assignment.
		 * @type {number}
		 */
		this.wave = objAssignment.wave;
		/**
		 * Trained state of assignment.
		 * @type {boolean}
		 */
		this.trained = objAssignment.trained;
		/**
		 * Collection of training tracks associated with assignment's job category.
		 * @type {TrainingTrack[]}
		 */
		this.trainingTracks = objAssignment.trainingTracks;
	}
}

export class BaseEsoDTO {
	constructor(objBaseEso) {
		/**
		 * @type {number}
		 */
		this.ID = objBaseEso.ID;
		/**
		 * @type {string}
		 */
		this.Name = objBaseEso.Name;
		/**
		 * @type {string}
		 */
		this.ESOID = objBaseEso.ESOID;
		/**
		 * @type {string}
		 */
		this.FamiliarESOID = objBaseEso.FamiliarESOID;
		/**
		 * @type {string}
		 */
		this.NetworkID = objBaseEso.NetworkID;
		/**
		 * @type {string}
		 */
		this.Email = objBaseEso.Email;
		/**
		 * @type {string}
		 */
		this.JobTitle = objBaseEso.JobTitle;
		/**
		 * @type {string}
		 */
		this.Department = objBaseEso.Department;
		/**
		 * @type {number}
		 */
		this.AccountTypeID = objBaseEso.AccountTypeID;
		/**
		 * @type {string}
		 */
		this.Manager = objBaseEso.Manager;
		/**
		 * @type {string}
		 */
		this.RetireDate = objBaseEso.RetireDate;
		/**
		 * @type {boolean}
		 */
		this.Primary = objBaseEso.Primary;
	}
}
